import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 64776 56181"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:717.823}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528317593568">
        <path
          d="M60752 2770H4023c-245 0-444-199-444-445s199-445 444-445h56729c246 0 445 199 445 445s-200 445-445 445z"
          className="fill stroke1"
          style={{
            strokeWidth: 717.823,
          }}
        />
        <path
          d="M2325 1248c-594 0-1077 483-1077 1077 0 593 483 1077 1077 1077s1077-484 1077-1077c0-594-484-1077-1077-1077zm0 3043c-1084 0-1966-882-1966-1966S1241 359 2325 359s1967 882 1967 1966-883 1966-1967 1966zM62451 1248c-595 0-1077 483-1077 1077 0 593 482 1077 1077 1077 593 0 1075-484 1075-1077 0-594-482-1077-1075-1077zm0 3043c-1086 0-1967-882-1967-1966s881-1966 1967-1966c1083 0 1966 882 1966 1966s-883 1966-1966 1966zM17662 34433H6837c-246 0-445-200-445-445 0-246 199-445 445-445h10825c1992 0 3613-1621 3613-3613V2325c0-245 198-445 444-445s445 200 445 445v27605c0 2483-2020 4503-4502 4503z"
                    className="fill stroke1"
          style={{
            strokeWidth: 717.823,
          }}

        />
        <path
          d="M6392 55557V2325h890v51722c2355-1112 5097-1112 7452-1V37056c0-1447-1177-2623-2624-2623H9221c-246 0-445-200-445-445 0-246 199-445 445-445h2889c1937 0 3514 1577 3514 3513v18501l-668-390c-2436-1420-5460-1420-7896 0l-668 390z"
                    className="fill stroke1"
          style={{
            strokeWidth: 717.823,
          }}

        />
        <path
          d="M9670 26720c-246 0-445-199-445-445V12582c0-246 199-445 445-445s445 199 445 445v13693c0 246-199 445-445 445zM15179 51432c-86 0-172-25-247-76-1772-1181-3620-1547-5492-1089-1412 347-2316 1059-2325 1067-191 152-472 121-624-70-154-191-124-470 66-624 43-33 1039-827 2632-1226 1468-369 3743-460 6237 1202 204 137 260 413 123 617-86 129-227 199-370 199zM57937 34433H47114c-2484 0-4503-2020-4503-4503V2325c0-245 199-445 444-445 246 0 445 200 445 445v27605c0 1992 1621 3613 3613 3613h10824c246 0 446 199 446 445 0 245-200 445-446 445z"
                    className="fill stroke1"
          style={{
            strokeWidth: 717.823,
          }}

        />
        <path
          d="m58383 55557-670-390c-2433-1420-5458-1420-7893 0l-669 390V37056c0-1936 1577-3513 3515-3513h2889c246 0 445 199 445 445 0 245-199 445-445 445h-2889c-1448 0-2625 1176-2625 2623v16990c2354-1111 5098-1111 7452 1V2325c0-245 199-445 444-445 246 0 446 200 446 445v53232z"
                    className="fill stroke1"
          style={{
            strokeWidth: 717.823,
          }}

        />
        <path
          d="M55105 26720c-246 0-445-199-445-445V12582c0-246 199-445 445-445s445 199 445 445v13693c0 246-199 445-445 445zM49596 51432c-143 0-285-70-370-199-136-204-81-480 124-617 2493-1662 4767-1571 6237-1202 1591 399 2589 1193 2630 1226 191 154 222 434 68 626-154 190-434 220-626 68-8-8-912-720-2325-1067-1871-458-3719-92-5491 1089-76 51-162 76-247 76zM33411 46395c-246 0-446-200-446-445V2325c0-245 200-445 446-445s444 200 444 445v43625c0 245-198 445-444 445zM31364 46395c-245 0-445-200-445-445V2325c0-245 200-445 445-445 246 0 445 200 445 445v43625c0 245-199 445-445 445zM49335 48388H15302c-246 0-444-200-444-445s198-444 444-444h34033c245 0 444 199 444 444s-199 445-444 445z"
                    className="fill stroke1"
          style={{
            strokeWidth: 717.823,
          }}

        />
        <path
          d="M49335 46631H15302c-246 0-444-200-444-445 0-246 198-445 444-445h34033c245 0 444 199 444 445 0 245-199 445-444 445z"
                    className="fill stroke1"
          style={{
            strokeWidth: 717.823,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
